<template>
  <a-card :bordered="false" title="申请改单">
    <a-form-model v-if="detail" :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="类型">{{ detail.proCatalogStr }}</a-form-model-item>
      <a-form-model-item label="订单号">{{ orderId }}</a-form-model-item>
      <div class="m-title">商品信息</div>
      <a-form-model-item :label="detail.proCatalog == 2 ? '酒店名称' : '商品名称'">
        <span>{{ detail.proName }}</span>
      </a-form-model-item>
      <template v-if="detail.proCatalog == 2">
        <a-form-model-item label="房型">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item label="价格计划">{{ detail.ratePlanName }}</a-form-model-item>
        <a-form-model-item label="间数">{{ detail.roomSize }}</a-form-model-item>
        <a-form-model-item label="入住日期">{{ detail.checkInDate }}</a-form-model-item>
        <a-form-model-item label="离店日期">{{ detail.departureDate }}</a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item v-if="detail.proCatalog == 1" label="票型">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item v-if="detail.proCatalog == 83" label="套餐">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item label="数量">{{ detail.roomSize }}</a-form-model-item>
        <a-form-model-item v-if="detail.proCatalog == 1 || detail.proCatalog == 83" label="出游日期"
        >{{ detail.checkInDate }}
        </a-form-model-item>
      </template>
      <a-form-model-item label="结算金额">￥ {{ detail.orderAmount }}</a-form-model-item>
      <div class="m-title">联系人</div>
      <a-form-model-item label="姓名">
        <div style="display: inline-block;width: 200px">{{ detail.contactName }}</div>
        <a-input style="width: 249px" v-model="changeContactName" placeholder="填写更改内容"></a-input>
      </a-form-model-item>
      <a-form-model-item label="联系电话：">
        <div style="display: inline-block;width: 200px">{{ detail.contactPhone }}</div>
        <a-input style="width: 249px" v-model="changeContactPhone" placeholder="填写更改内容"></a-input>
      </a-form-model-item>
      <template v-if="detail.proCatalog == 2" style="width: 100%;">
        <div class="m-title">入住人</div>
        <a-form-model-item v-for="(item, index) in detail.travellersVoList" :label="getLiveName(index)" :key="index">
          <div style="width: 200px;display: inline-block">{{ item.travellersName }}</div>
          <a-input class="input-list" v-model="item.newTravellersName" placeholder="填写更改的入住人"></a-input>
          <a-select
            class="input-list"
            @change="value => onChangeOptionsEvent(item, index, value, 'options')"
            v-model="item.optionId"
            placeholder="请选择更改的房型"
          >
            <a-select-option v-for="item in roomOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select
            class="input-list"
            v-model="item.ratePlanId"
            placeholder="请选择更改价格计划"
            @change="value => onChangeOptionsEvent(item, index, value, 'ratePlan')"
          >
            <a-select-option v-for="optionItem in item.ratePlanList" :key="optionItem.id" :value="optionItem.id">
              {{ optionItem.name }}
            </a-select-option>
          </a-select>
          <a-date-picker
            format="YYYY-MM-DD"
            v-model="item.checkInDate"
            :disabledDate="disabledDate"
            placeholder="选择出游日期"
          >
          </a-date-picker>
        </a-form-model-item>
      </template>
      <template v-else-if="detail.proCatalog != 8">
        <div class="m-title">出游人</div>
        <a-form-model-item
          v-for="(item, index) in detail.travellersVoList"
          :label="getTravellerName(index)"
          :key="item.travellersId"
        >
          <span>
            <div class="detail-list">{{ item.travellersName }}</div>
            <div class="detail-list">{{ item.cardTypeStr }}</div>
            <div class="detail-list">{{ item.cardNo }}</div>
          </span>
          <div>
            <!--            <div class="detail-list">-->
            <!--              {{ item.travellersName }}-->
            <!--            </div>-->
            <a-input class="input-list" v-model="item.newTravellersName" placeholder="填写更改的出游人"></a-input>
            <a-select
              class="input-list"
              @change="value => onChangeOptionsEvent(item, index, value, 'options')"
              v-model="item.optionId"
              placeholder="请选择更换的套餐"
            >
              <a-select-option v-for="item in roomOptions" :key="item.id" :value="item.id">{{
                  item.name
                }}
              </a-select-option>
            </a-select>
            <a-select
              class="input-list"
              v-model="item.newCardType"
              placeholder="请选择证件类型"
              @change="value => onChangeOptionsEvent(item, index, value, 'cardType')"
            >
              <a-select-option v-for="cardItem in item.cardList" :value="cardItem.id" :key="cardItem.id">
                {{ cardItem.name }}
              </a-select-option
              >
            </a-select>
            <a-input class="input-list" v-model="item.newCardNo" placeholder="填写更改证件号"></a-input>
            <a-date-picker
              format="YYYY-MM-DD"
              v-model="item.checkInDate"
              :disabledDate="disabledDate"
              placeholder="选择出游日期"
            >
            </a-date-picker>
          </div>
        </a-form-model-item>
      </template>
      <a-form-model-item label="改单原因：">
        <a-textarea
          style="width: 400px;"
          placeholder="请填写改单原因140字以内"
          :maxLength="140"
          v-model="refundRemark"
          :rows="2"
        ></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" style="width: 100px;margin-right:20px;" @click="confirmEvent">确认</a-button>
        <a-button type="primary" style="width: 100px;" @click="cancelEvent">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ChangeOrder',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      detail: {
        travellersVoList: [
          {
            checkInDate: null
          }
        ]
      },
      merchantName: this.$store.getters.userInfo.merchantName,
      orderId: '',
      refundRemark: '',
      changeContactName: undefined,
      changeContactPhone: undefined,
      roomOptions: [], //房型信息
      planOptions: [] //计划信息
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
    this.orderId = this.$route.query.orderId
  },
  mounted() {
    this.getOrderDetails(this.orderId)
  },
  methods: {
    moment,
    //日期禁选
    disabledDate(current) {
      return current && current < moment().endOf('day') - 8.64e7
    },
    getOrderDetails(orderId) {
      this.getHttpServices()
        .getResourceService()
        .post('order/getOrderDetails/' + orderId)
        .then(res => {
          res.travellersVoList.forEach((item, index, arr) => {
            item.ratePlanList = []
            item.ratePlanId = undefined
            item.checkInDate = null
          })
          this.detail = res
          if (res.proCatalog !== 8) {
            this.getOptionList(this.detail.proId, this.detail.proCatalog)
          }
        })
        .catch(err => {
          this.getLogUtils().logWithTag('请求失败')
          this.getLogUtils().logWithTag('err', err)
        })
    },
    getOptionList(proId, proCatalogId) {
      let params = {
        proCatalogId: proCatalogId,
        proId: proId
      }
      this.getHttpServices()
        .getProService()
        .post('product/option/getOptionList', params)
        .then(res => {
          this.roomOptions = res
        })
        .catch(err => {
          this.getLogUtils().logWithTag('请求失败')
          this.getLogUtils().logWithTag('err', err)
        })
    },
    getRatePlanList(optionId) {
      const url = 'product/hotel/RatePlan/getRatePlanList/' + optionId
      return new Promise((resolve, reject) => {
        this.getHttpServices()
          .getProService()
          .post(url)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      })
    },
    //获取证件类型
    getCardTypeList(optionId) {
      const params = {
        optionId: optionId,
        proCatalogId: this.detail.proCatalog,
        proId: this.detail.proId
      }
      return new Promise((resolve, reject) => {
        this.getHttpServices()
          .getProService()
          .post('product/option/getOptionTouristinformation', params)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      })
    },
    getLiveName(index) {
      return '入住人' + (index + 1) + '：'
    },
    getTravellerName(index) {
      return '出游人' + (index + 1) + '：'
    },
    //参数变更监听
    onChangeOptionsEvent(item, index, value, name) {
      if (name === 'options') {
        //房型
        const selectedItem = this.roomOptions.find((item, i, arr) => value === item.id)
        item.optionName = selectedItem ? selectedItem.name : ''
        if (this.detail.proCatalog == 2) {
          //酒店才有
          item.ratePlanId = ''
          item.ratePlanName = ''
          item.ratePlanList = []
          this.getRatePlanList(value)
            .then(list => {
              this.detail.travellersVoList[index].ratePlanList = list
              this.detail = { ...this.detail }
            })
            .catch(reason => this.getLogUtils().logWithTag('getRatePlanList', reason))
        } else {
          //获取证件信息
          item.cardList = []
          //item.newCardNo = ''
          item.newCardType = ''
          this.getCardTypeList(value)
            .then(list => {
              this.detail.travellersVoList[index].cardList = list
              this.detail = { ...this.detail }
            })
            .catch(reason => this.getLogUtils().logWithTag('getCardTypeList', reason))
        }
      } else if (name === 'ratePlan') {
        //修改计划
        const selectedItem = this.detail.travellersVoList[index].ratePlanList.find((item, i, arr) => value === item.id)
        item.ratePlanName = selectedItem ? selectedItem.name : ''
      } else if (name === 'cardType') {
        //item.newCardNo = null
      }
      this.detail = { ...this.detail }
    },
    //获取出游人信息
    getChangeTravellersDtoList() {
      const newList = []
      let change = false //标记数据是否改变
      let changeItem = {}
      this.detail.travellersVoList.forEach((item, index, arr) => {
        if (item.newTravellersName) {
          changeItem.travellersName = item.newTravellersName
          change = true
        }
        if (item.checkInDate) {
          changeItem.checkInDate = item.checkInDate.format('YYYY-MM-DD')
          change = true
        }
        if (this.detail.proCatalog == 2) {
          if (item.ratePlanId && item.optionId) {
            changeItem.optionId = item.optionId
            changeItem.optionName = item.optionName
            changeItem.ratePlanName = item.ratePlanName
            changeItem.ratePlanId = item.ratePlanId
            change = true
          }
        } else {
          if (item.optionId) {
            changeItem.optionId = item.optionId
            changeItem.optionName = item.optionName
            change = true
          }
        }
        if (item.newCardNo) {
          changeItem.cardNo = item.newCardNo
          change = true
        }
        if (item.newCardType) {
          changeItem.cardType = item.newCardType
          change = true
        }

        if (change) {
          changeItem.travellersId = item.travellersId
          newList.push(changeItem)
          change = false
          changeItem = {}
        }
      })
      return newList
    },
    confirmEvent() {
      const list = this.getChangeTravellersDtoList()
      if (!this.verificationContactField() && list.length < 1) {
        this.$message.error('订单信息没有修改')
        return
      }
      const params = {
        changeContactName: this.changeContactName,
        changeContactPhone: this.changeContactPhone,
        changeTravellersDtoList: list,
        createName: this.merchantName,
        orderId: this.orderId,
        orderRemark: this.refundRemark
      }
      this.getHttpServices()
        .getResourceService()
        .post('order/changeOrderInfo', params)
        .then(res => {
          this.$message.success('改单申请成功')
          setTimeout(() => this.cancelEvent(), 100)
        })
        .catch(err => {
          this.$message.error('改单申请失败')
        })
    },
    cancelEvent() {
      this.$router.back(-1)
    },
    //验证联系人信息
    verificationContactField() {
      if (this.changeContactName) {
        return true
      }
      if (this.changeContactPhone) {
        return true
      }
      return false
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

.m-title {
  color: #444444;
  font-weight: bold;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9e9e9;
  margin-bottom: 20px;
  margin-left: 20px;
}

.detail-list {
  margin-right: 20px;
  width: 200px;
  display: inline-block;
}

.input-list {
  width: 200px;
  margin-right: 20px;
}
</style>
